module.exports = __webpack_public_path__ + "static/student.df5e8f96.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/plans/student.jpg
// module id = 1341
// module chunks = 4